const findProdutosAlternativeFlat = (request) => {
  let result = [];

  request.forEach((item) => {
    if (
      item.codigobarras?.length > 1 ||
      item.codigobarras.find((current) => current.codbarras_codigoalternativo)
    ) {
      item.codigobarras.forEach((barCode) => {
        result.push({ ...item, ...barCode });
      });
    } else {
      result.push({
        ...item,
        codigo: item.codigobarras[0].codigo,
        descricao_final: item.codigobarras[0].descricao_final,
      });
    }
  });

  return result;
};

export { findProdutosAlternativeFlat };
